export { default } from "./TrashIcon";
